import {Text, UnifonTheme} from '@phonectas/unifon-ui-kit';
import sc from 'styled-components';

const MrcTableWrapper = sc.div`
	width: 100%;
	height: 100%;
	overflow-x: auto;
	margin-bottom: 40px;
	position: relative;
	transform: translateZ(0);
	-webkit-transform: translateZ(0);
`;

const MrcTable = sc.table`
	width: 100%;
	min-width: 800px;
	// height: 100%;
	border-collapse: separate;
	border-spacing: 0;
	position: relative;
`;

const MrcHeader = sc.thead<{theme: UnifonTheme}>`
	position: sticky;
	top: 0;
	left: 0;
	width: 100%;
	background: ${({theme}) => theme.palette.lightSecondary};
	z-index: 1; // Only within the transform context
    
    tr {
        background: ${({theme}) => theme.palette.lightSecondary};
    }

`;

const MrcTh = sc.th<{width?: string | number, theme: UnifonTheme}>`
  padding: 12px;
  text-align: left;
  color: ${({theme}) => theme.palette.secondary};
  ${({width}) => width && `width: ${typeof width === 'number' ? `${width}px` : width};`}
  position: relative;
`;

const MrcTd = sc.td<{
	$isRowLast?: boolean;
	$isFirst?: boolean;
	$isLast?: boolean;
	$expanded?: boolean;
	theme?: UnifonTheme;
	$isError?: boolean;
	$isSigned?: boolean;
	$mrcFailed?: boolean;
}>`
    padding: 8px 12px;
    height: 52px;
    border-top: ${({theme, $mrcFailed}) => $mrcFailed ? `1px solid ${theme.palette.error}` : '1px solid #e6e6ea'};
    border-bottom: ${({theme, $mrcFailed}) => $mrcFailed ? `1px solid ${theme.palette.error}` : undefined};
    color: ${({$expanded, theme}) =>
		$expanded ? theme.palette.white : undefined};
    background: ${({$expanded, theme, $isError, $isSigned, $mrcFailed}) =>
		$isSigned && $expanded
			? '#27AD61'
			: $expanded
				? $isError || $mrcFailed
					? theme.palette.error
					: theme.palette.primary
				: theme.palette.white};
    ${({$isFirst, $expanded, theme}) =>
		$isFirst &&
        `
        border-top-left-radius: ${theme ? theme.borderRadius * 2 : 8}px;
        ${$expanded ? 'border-bottom-left-radius: 0px;' : 'border-bottom-left-radius: 8px;'}
        `}
    ${({$isLast, $expanded, theme}) =>
		$isLast &&
        `
        border-top-right-radius: ${theme ? theme.borderRadius * 2 : 8}px;
        ${$expanded ? 'border-bottom-right-radius: 0px;' : 'border-bottom-right-radius: 8px;'}
        `}
`;

const MrcTr = sc.tr``;

const MrcTrBody = sc.tr`
	background: #fff;
	transition: background 0.2s;
	&:hover {
		opacity: 0.8;
	}
`;

const MrcScrollArea = sc.div`
  height: 100%;
  overflow-y: auto;
  transform: translateZ(0);
  position: relative;
`;

const MrcResendButton = sc.button<{theme: UnifonTheme}>`
	background: transparent;
	border: 1px solid ${({theme}) => theme.palette.primary};
	color: ${({theme}) => theme.palette.primary};
	cursor: pointer;
	border-radius: 4px;
	height: 100%;
	min-height: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;

	&:hover {
		background: ${({theme}) => theme.palette.primary};
		color: #fff;
	}
`;

const MrcExpandedRowTd = sc.td<{$expanded?: boolean, theme?: UnifonTheme}>`
	padding: 0;
	border: 0;
	border-radius: ${({theme}) => {
		const radius = theme.borderRadius * 2;
		return `0 0 ${radius}px ${radius}px`;
	}};
	background: ${({theme}) => theme.palette.white};
`;

const MrcExpandedRowContent = sc.div<{$expanded?: boolean, theme?: UnifonTheme}>`
	padding: ${({$expanded}) => ($expanded ? '16px' : '0 16px')};
	max-height: ${({$expanded}) => ($expanded ? '500px' : '0')};
	overflow: hidden;
	transition: max-height 0.5s cubic-bezier(0.4,0,0.2,1), padding 0.3s;
	will-change: max-height, padding;
	box-sizing: border-box;
	display: block;
`;

const MrcStyledText = sc(Text)`
	white-space: pre-line;
	word-break: break-word;
`;

export {
	MrcTableWrapper,
	MrcTable,
	MrcTh,
	MrcTd,
	MrcTr,
	MrcTrBody,
	MrcHeader,
	MrcScrollArea,
	MrcStyledText,
	MrcResendButton,
	MrcExpandedRowTd,
	MrcExpandedRowContent,
};